var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFDD67;}\r\n\t.st3{fill:#664E27;}\r\n\t.st4{fill:#4C3526;}\r\n\t.st5{fill:#FF717F;}\r\n\t.st6{fill:#EF5350;}\r\n\t.st7{fill:#302424;}\r\n\t.st8{fill:#E0A372;}\r\n\t.st9{fill:#FFE1BD;}\r\n\t.st10{fill:#E6B796;}\r\n\t.st11{fill:#42ADE2;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.2,35.4l19.2,38.9l3,6.1l6.8,1l42.9,6.2L141,117.9l-4.9,4.8l1.2,6.7l7.3,42.7L106.2,152l-6-3.2l-6,3.2l-38.4,20.2 l7.3-42.7l1.2-6.7l-4.9-4.8L28.3,87.6l42.9-6.2l6.8-1l3-6.1L100.2,35.4 M100.2,6L69.3,68.5l-69,10l49.9,48.7l-11.8,68.7l61.7-32.4 l61.7,32.4l-11.8-68.7L200,78.5l-69-10L100.2,6L100.2,6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.8b8c1813.svg";
export { ForwardRef as ReactComponent };